/**
 * Validate whether an item matches allowed portal types and is publishable.
 *
 * Conditions:
 * - Item must exist
 * - Item must have a portal type (supports both `portal_type` and `@type`)
 * - Portal type must be included in the allowed `types` array
 * - Item must be published OR have no review_state (treated as published)
 *
 * @param {Object} item - The content item to validate
 * @param {string[]} types - List of allowed portal types
 * @returns {boolean} True if item is valid, false otherwise
 */
export const validateType = (item, types) => {
  if (!item) return false; 
  else {
    const portal_type = item.portal_type || item['@type'];
    const is_published = !item.review_state || item.review_state === 'published';
    return (
      portal_type 
      && types.includes(portal_type) 
      && is_published
    );
  }
};